import React, { Component } from 'react';
import { NavLink as Link } from 'react-router-dom';
import {
    Container, Row, Col,
    Card, CardHeader, CardBody, CardFooter,
    Alert
} from 'reactstrap';

import { Form, Input, Button } from 'muicss/react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import Logo from './../../assets/DAPSwhitelogo.png';

const cookies = new Cookies();
const prebase = window.location.protocol + '//' + window.location.host
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;
const qs = require('qs');

class AddDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            email: '',
            phone_number: '',
            alertShow: false,
            alertMessage: '',
            color: 'danger',
            method: qs.parse(props.location.search, {ignoreQueryPrefix: true}).method,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);        
        this.loadUser = this.loadUser.bind(this);
        this.loadUser()
    }

    loadUser() {
        let authToken = cookies.get('auth_token')   
        axios.get(`${base}/api/auth/current_user`,
        {
            withCredentials: true,
            headers: {
                'Authorization': `Token ${authToken}`
            }
        }).then(response => {
            let user = response.data
            this.setState({email: user.email, phone_number: user.phone_number, id: user.id})
        }).catch(error => {
            console.log(error.response.data)
        })
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        let authToken = cookies.get('auth_token')  
        let csrfToken = cookies.get('csrftoken')
        let data = {
            csrfmiddlewaretoken: csrfToken,
            id: this.state.id
        }
        if (this.state.method === 'email') {
            data['email'] = this.state.email
        } else if (this.state.method === 'sms_twilio') {
            data['phone_number'] = this.state.phone_number
        }
        axios.put(`${base}/api/auth/current_user/`,
        data,
        {
            withCredentials: true,
            headers: {
                'X-CSRFToken': csrfToken,
                'Authorization': `Token ${authToken}`
            }
        }).then(response => {
            data = {
                method: this.state.method
            }
            if (this.state.method === 'sms_twilio') {
                data['profile'] = response.data.id
            }
            axios.post(`${base}/api/mfaAuth/${this.state.method}/activate/`, data, 
            {
                withCredentials: true, 
                headers: {
                    'X-CSRFToken': csrfToken, 
                    'Authorization':  `Token ${authToken}`
                }
            }).then((response) => {
                cookies.get('mfa_configure') ? this.props.history.push(`/mfa-confirm?method=${this.state.method}`) : this.props.history.push(`/admin/mfa-confirm?method=${this.state.method}`)
            }).catch(error => {
                console.log(error.response.data)
            })
        }).catch(error => {
            console.log(error.response.data)
        })
    }

    render() {
        return (
            <Container>
                <Row className="p-4">
                    <Col sm="12" md="6" className="text-center" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        <img src={Logo} alt="DAPS Health Logo" style={{maxHeight: '80%', maxWidth: '80%'}} />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md='6' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        <Card>
                            <Form onSubmit={this.handleSubmit}>
                                <CardHeader>
                                    <legend>Add MFA Method Details</legend>
                                </CardHeader>
                                <CardBody>
                                    <Alert className="m-2" color={this.state.color} isOpen={this.state.alertShow} toggle={() => { this.setState({ alertShow: false }) }}>
                                        {this.state.alertMessage}
                                    </Alert>
                                    {this.state.method === 'email' && <fieldset>
                                        <label htmlFor="user-email">Email</label>
                                        <Input type="text" name="email" id="user-email" value={this.state.email} onChange={this.handleInputChange} autoFocus/>
                                    </fieldset>}
                                    {this.state.method === 'sms_twilio' && <fieldset>
                                        <label htmlFor="user-phone">Phone Number</label>
                                        <Input type="text" name="phone_number" id="user-phone" value={this.state.phone_number} onChange={this.handleInputChange} autoFocus/>
                                    </fieldset>}
                                </CardBody>
                                <CardFooter>
                                    <Button className="bg-success" color="primary" variant="raised">Submit</Button>
                                </CardFooter>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default AddDetails;